import { render, staticRenderFns } from "./Goods_list.vue?vue&type=template&id=4280fc16&"
import script from "./Goods_list.vue?vue&type=script&lang=js&"
export * from "./Goods_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports